<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="40%"
    @close="handleClose"
  >
    <temlate v-if="!isAddSuccess">
      <el-form :model="form" ref="appForm" :rules="rules" label-width="170px">
        <el-form-item prop="name" :label="this.$t('developer.name')">
          <el-input
            v-model.trim="form.name"
            autocomplete="off"
            :placeholder="this.$t('developer.appNamePla')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('developer.des')" prop="des">
          <el-input
            v-model.trim="form.des"
            type="textarea"
            :placeholder="this.$t('developer.desPla')"
          ></el-input>
        </el-form-item>
      </el-form>
    </temlate>
    <template v-else>
      <div>
        <p>{{ $t('developer.createAppSucess') }}</p>
        <ZkKvLine :label="'AppKey'">{{ appDetailInfo.appKey }}</ZkKvLine>
        <ZkKvLine :label="'AppSecret'">{{ appDetailInfo.appSecret }}</ZkKvLine>
        <ZkKvLine :label="'EndPoint'">{{ endPoint }}</ZkKvLine>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">
        {{ isAddSuccess ? $t('developer.isOk') : $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="submitAddOrUpdate">
        {{ isAddSuccess ? $t('developer.enterApp') : $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { validatorInputEmptyRule } from '@/utils/validatorRule.js'
import { saveOrUpdateApp } from '@/services/appManagerApi.js'
export default {
  props: {
    title: {
      type: String
    },
    appForm: {
      type: Object
    },
    isUpdate: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    endPoint: {
      type: String
    }
  },
  watch: {
    appForm: {
      handler(val) {
        if (val) {
          let keys = Object.keys(val) || []
          if (keys.length) {
            this.form.name = val.name
            this.form.des = val.des
          } else {
            this.form.name = ''
            this.form.des = ''
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      isAddSuccess: false,
      form: {
        name: '',
        des: ''
      },
      rules: {
        name: validatorInputEmptyRule(true, 32)
      },
      appDetailInfo: {}
    }
  },
  methods: {
    submitAddOrUpdate() {
      if (!this.isAddSuccess) {
        // 添加应用| 更新应用
        this.$refs.appForm.validate(valid => {
          if (valid) {
            let params = {}
            if (this.isEdit) {
              //  更新
              params = Object.assign({}, this.appInfo, this.form)
              delete params.appSecret
            } else {
              //  新增
              params = this.form
            }
            saveOrUpdateApp(params)
              .then(data => {
                if (data.code === '00000000') {
                  //  重新加载应用列表 | 应用信息
                  if (this.isEdit) {
                    this.$parent.getAppInfo()
                    this.dialogVisible = false
                  } else {
                    this.appDetailInfo = data.payload.results
                    !this.isUpdate && (this.isAddSuccess = true)
                  }
                } else {
                  this.errorMessage(data.message)
                }
              })
              .catch(e => console.error('error submitAddOrUpdate()'))
          }
        })
      } else {
        // 进入应用
        this.$emit('enterApp', this.appDetailInfo)
      }
    },
    showDailog() {
      this.dialogVisible = true
      this.isAddSuccess = false
      this.isUpdate = false
    },
    isEditApp(appInfo) {
      this.isEdit = true
      this.appInfo = appInfo
      this.form.name = appInfo.name
      this.form.des = appInfo.des
    },
    handleClose() {
      // dailog 调用的两次
      this.dialogVisible = false

      if (!this.isEdit) {
        if (this.$refs.appForm) {
          this.$refs.appForm.resetFields()
        }
      }
      if (!this.isUpdate) {
        // q1:  编辑的时候  这个方法没有
        try {
          this.$parent.loadAppList()
        } catch (error) {}
      }
    }
  },
  mounted() {}
}
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/modules/developer/appSetting/appInfo.vue